export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_BACK_END_URL || 'http://127.0.0.1:4000/api';

export const BACKEND_BASE_URL = import.meta.env.VITE_BACK_END_URL || 'http://127.0.0.1:4000';

// Offline dev mode: Mock empty backend responses
// Uncomment to disable all API calls:
// window.fetch = () => Promise.resolve({ ok: true, json: () => Promise.resolve({ data: [], success: true }) }) as any;


